import React from 'react';
import './index.css';
import { Tabs } from 'antd';


interface Tabprops {
    defaultActiveKey: string,
    tabItems: any
}

const CustomTabs: React.FC<Tabprops> = ({ defaultActiveKey, tabItems }) => {

    return <div className='customTabs'>
        <Tabs defaultActiveKey={defaultActiveKey} centered size='large'>
            {tabItems.map((tabProp: any) => (
                <Tabs.TabPane tab={tabProp.label} key={tabProp.key}>
                    <tabProp.children />
                </Tabs.TabPane>
            ))

            }
        </Tabs>

    </div>


}

export default CustomTabs;
